import ky from 'ky';
import { makeAddItemsToCart } from './add-items-to-cart';
import { makeChangeItemQuantity } from './change-item-quantity';
import { makeFetchCartContents } from './fetch-cart-contents';
import { makeUpdateCartNote } from './update-cart-note';
import { makeUpdateCartAttributes } from './update-cart-attributes';
export const agent = ky.create({
    retry: {
        limit: 3,
        methods: [
            'get'
        ]
    },
    hooks: {
        beforeError: [
            async (err)=>{
                const { response  } = err;
                try {
                    console.warn('Cart API error', response.status, response.body, response.type);
                } catch (_err) {
                    console.error('Cart error response cannot be processed', _err, response);
                }
                return err;
            }
        ]
    }
});
export const Context = {
    addItemsToCart: makeAddItemsToCart(),
    changeItemQuantity: makeChangeItemQuantity(),
    fetchCartContents: makeFetchCartContents(agent),
    updateCartAttributes: makeUpdateCartAttributes(agent),
    updateCartNote: makeUpdateCartNote(agent)
};
